<template>
  <div class="w-full h-1 bg-surface rounded-sm overflow-hidden">
    <div
      v-if="value"
      :style="{ width: `${value}%` }"
      class="h-full bg-accent transition-[width] duration-200 ease"
    />
    <div
      v-else
      class="h-full w-1/2 bg-accent animate-progress-indeterminate"
    />
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Number,
    default: 0
  }
})
</script>
